// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 6630 ? "SeoPages" : chunkId) + "_" + {"2425":"01200d4a3d000c6c","6630":"f9b7faa15294570e"}[chunkId] + ".css";
};